export default (...classes: Array<string | undefined | null>): string =>
    classes.filter((className) => !!className).join(' ')
